/**
 * â”Œâ”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”
 * â”‚ This file has been generated by designTokens.ts                       â”‚
 * â”‚                                                                        â”‚
 * â”‚ Source of truth: figma-design-tokens-core.json                         â”‚
 * â”‚                  figma-design-tokens-components.json                   â”‚
 * â”‚ Extra reference normalization lives in the generator script.           â”‚
 * â”‚ Please do not edit this file manually.                                 â”‚
 * â”‚ Run: yarn tokens                                                       â”‚
 * â””â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”˜
 */

import { generateBreakpoints } from "./theme.helper.ts";

// Direct Figma palette tokens.
const figmaPalette = {
	ui: {
		1: "#1c1a18",
		2: "#46403c",
		3: "#5d5854",
		4: "#b2afac",
		5: "#ccc9c6",
		6: "#e4e3e1",
		7: "#f5f4f3",
		8: "#ffffff",
	},
	primary: {
		200: "#cfe1ff",
		300: "#87adf5",
		500: "#1259ef",
		700: "#28169b",
	},
	shine: {
		300: "#ffe6b1",
		500: "#ffcd62",
		600: "#b98108",
		700: "#ffaa00",
	},
	sunset: {
		300: "#ffc9c9",
		500: "#ff5a5a",
		600: "#e71f1f",
		700: "#9e1515",
	},
	harvest: {
		300: "#c6ffc9",
		500: "#8eff94",
		600: "#437d46",
		700: "#2a4b2c",
	},
	cozy: {
		200: "#ebe5ff",
		300: "#cdc4ff",
		500: "#7154e6",
		700: "#2c145b",
	},
	warm: {
		100: "#fbf9f7",
		200: "#f5f0ea",
		300: "#e9e2d9",
		500: "#66615b",
	},
} as const;

// Generator-owned config values that are not present in the Figma export yet.
const generatorPaletteConfig = {
	action: {
		focus: "#80C5FF",
	},
	reserved: {
		inherit: "inherit",
		transparent: "rgba(0,0,0,0)",
	},
	base: "#fff",
} as const;

const palette = {
	...figmaPalette,
	...generatorPaletteConfig,
} as const;

// Direct Figma semantic tokens mapped back to palette references.
const semantic = {
	"color-text": {
		ui: {
			primary: palette.ui[1],
			secondary: palette.ui[2],
			subtle: palette.ui[3],
			link: palette.primary[500],
			"on-dark-bg": palette.ui[8],
			muted: palette.ui[4],
		},
		feedback: {
			error: palette.sunset[600],
			info: palette.primary[500],
			warning: palette.shine[600],
			success: palette.harvest[600],
			promotional: palette.cozy[500],
		},
	},
	"color-ui": {
		"surface-default": palette.ui[8],
		page: palette.ui[7],
		"dark-subtle": palette.ui[2],
		dark: palette.ui[1],
		"light-subtle": palette.ui[7],
		primary: {
			highlight: palette.primary[700],
			contrast: palette.primary[500],
			medium: palette.primary[300],
			subtle: palette.primary[200],
		},
		shine: {
			highlight: palette.shine[700],
			contrast: palette.shine[500],
			subtle: palette.shine[300],
		},
		harvest: {
			highlight: palette.harvest[700],
			contrast: palette.harvest[500],
			subtle: palette.harvest[300],
		},
		sunset: {
			highlight: palette.sunset[700],
			contrast: palette.sunset[500],
			subtle: palette.sunset[300],
		},
		cozy: {
			dark: palette.cozy[700],
			contrast: palette.cozy[300],
			subtle: palette.cozy[200],
			highlight: palette.cozy[500],
		},
		light: palette.ui[6],
		warm: {
			highlight: palette.warm[300],
			contrast: palette.warm[200],
			subtle: palette.warm[100],
		},
		medium: palette.ui[4],
		"medium-subtle": palette.ui[5],
	},
	"color-border": {
		"surface-module": palette.ui[7],
		"surface-default": palette.ui[5],
		"surface-light": palette.ui[4],
	},
	"color-feedback": {
		bg: {
			caution: palette.shine[300],
			danger: palette.sunset[300],
			information: palette.primary[200],
			positive: palette.harvest[300],
			promotion: palette.cozy[200],
		},
	},
	"color-icon": {
		ui: {
			primary: palette.ui[1],
			secondary: palette.ui[2],
			subtle: palette.ui[3],
			link: palette.primary[500],
			"on-dark-bg": palette.ui[8],
			muted: palette.ui[4],
		},
		feedback: {
			error: palette.sunset[600],
			info: palette.primary[700],
			warning: palette.shine[600],
			success: palette.harvest[600],
		},
	},
} as const;

// Generator-owned config values that still need to be emitted alongside the Figma-derived theme.
const breakpoint = generateBreakpoints({
	mobile: 480,
	tablet: {
		landscape: 1024,
		portrait: 768,
	},
	desktop: 1280,
	desktopLarge: 1600,
});
const typography = {
	weight: {
		bold: 700,
		medium: 500,
		regular: 400,
		semibold: 600,
	},
} as const;
const spacing = {
	0: "0px",
	4: "4px",
	6: "6px",
	8: "8px",
	12: "12px",
	16: "16px",
	24: "24px",
	32: "32px",
	40: "40px",
	48: "48px",
} as const;
const modal = {
	"padding-top": "50px",
	"padding-bottom": "90px",
	"content-padding": "16px",
	"content-max-height": "calc(100vh - #{$modal-padding-top} - #{$modal-padding-bottom} - 57px - 69px)",
} as const;

// Compatibility aliases kept for existing consumers.
const color = {
	...palette,
	success: {
		...palette.harvest,
		100: palette.harvest[300],
		200: palette.harvest[300],
	},
	warning: {
		...palette.shine,
		100: palette.shine[300],
		200: palette.shine[300],
	},
	destructive: {
		...palette.sunset,
		100: palette.sunset[300],
		200: palette.sunset[300],
	},
	lilac: palette.cozy,
	burgundy: {
		100: palette.cozy[200],
		200: palette.cozy[200],
		300: palette.cozy[300],
		500: palette.cozy[500],
		700: palette.cozy[700],
	},
} as const;

export type StandardSpacingNumbers = keyof typeof spacing;
export type StandardSpacingNames = `${StandardSpacingNumbers}`;

export const theme = {
	color,
	palette,
	semantic,
	breakpoint,
	typography,
	spacing,
	modal,
};

type NestedKeyOf<ObjectType extends object> = {
	[Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
		? `${Key}` | `${Key}-${NestedKeyOf<ObjectType[Key]>}`
		: `${Key}`;
}[keyof ObjectType & (string | number)];

type LegacyColorLevels =
	| "primary-100"
	| "success-100"
	| "success-200"
	| "warning-100"
	| "warning-200"
	| "destructive-100"
	| "destructive-200"
	| "burgundy-100"
	| "burgundy-200"
	| "burgundy-300"
	| "burgundy-500"
	| "burgundy-700";

export type CssVariableColorNames =
	| Exclude<`${NestedKeyOf<typeof palette>}`, keyof typeof palette>
	| Exclude<`${NestedKeyOf<typeof color>}`, keyof typeof color>
	| LegacyColorLevels;